import { Link } from 'react-router-dom';
import useSectionAnimation from '@/hooks/useSectionAnimation';

const categories = [
  {
    icon: 'ri-book-open-line',
    label: 'تعليم وتطوير',
    count: '285 حملة',
    image: 'https://readdy.ai/api/search-image?query=education%20learning%20books%20students%20Saudi%20Arabia%20modern%20classroom%20warm%20tones&width=400&height=300&seq=402&orientation=landscape',
  },
  {
    icon: 'ri-briefcase-line',
    label: 'مشاريع ريادية',
    count: '193 حملة',
    image: 'https://readdy.ai/api/search-image?query=startup%20entrepreneur%20business%20Saudi%20Arabia%20modern%20office%20innovation%20team&width=400&height=300&seq=403&orientation=landscape',
  },
  {
    icon: 'ri-palette-line',
    label: 'إبداع وفنون',
    count: '312 حملة',
    image: 'https://readdy.ai/api/search-image?query=Arabic%20art%20creative%20calligraphy%20painting%20music%20culture%20Saudi%20Arabia%20warm%20artistic&width=400&height=300&seq=404&orientation=landscape',
  },
  {
    icon: 'ri-code-line',
    label: 'تقنية وبرمجة',
    count: '157 حملة',
    image: 'https://readdy.ai/api/search-image?query=technology%20programming%20coding%20laptop%20developer%20Saudi%20Arabia%20modern%20workspace%20warm&width=400&height=300&seq=407&orientation=landscape',
  },
  {
    icon: 'ri-restaurant-line',
    label: 'طعام ومطاعم',
    count: '124 حملة',
    image: 'https://readdy.ai/api/search-image?query=Saudi%20food%20restaurant%20chef%20cooking%20traditional%20cuisine%20warm%20kitchen%20inviting&width=400&height=300&seq=408&orientation=landscape',
  },
  {
    icon: 'ri-plant-line',
    label: 'بيئة وزراعة',
    count: '89 حملة',
    image: 'https://readdy.ai/api/search-image?query=organic%20farm%20green%20agriculture%20sustainable%20environment%20Saudi%20Arabia%20nature&width=400&height=300&seq=406&orientation=landscape',
  },
];

const CategorySection = () => {
  const { ref, fadeUp, stagger } = useSectionAnimation({ threshold: 0.08 });

  return (
    <section ref={ref} className="py-20 bg-white" dir="rtl">
      <div className="max-w-7xl mx-auto px-8 md:px-12">
        <div className="flex items-end justify-between mb-10" style={fadeUp}>
          <div>
            <span className="text-emerald-600 text-sm font-semibold tracking-wide uppercase">تصفح حسب الفئة</span>
            <h2 className="text-2xl md:text-4xl font-black text-stone-800 mt-1">اختر ما يهمك</h2>
          </div>
          <Link
            to="/explore"
            className="hidden md:inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-semibold text-sm cursor-pointer whitespace-nowrap"
          >
            عرض الكل
            <i className="ri-arrow-left-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat, i) => (
            <Link
              key={i}
              to="/explore"
              className="group relative overflow-hidden rounded-2xl cursor-pointer"
              style={stagger(i, 70)}
            >
              <div className="h-36 md:h-44 relative">
                <img
                  src={cat.image}
                  alt={cat.label}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 right-0 left-0 p-3">
                  <div className="font-bold text-white text-xs mb-0.5">{cat.label}</div>
                  <div className="text-white/70 text-xs">{cat.count}</div>
                </div>
                <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-lg bg-white/20 backdrop-blur-sm">
                  <i className={`${cat.icon} text-white text-sm`}></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
